







































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { TermsTab } from "@/shared/types";
import { BankCustodian } from "@/admin/types";
import { FeatureFlags } from "@/shared/flagging";

import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import TermsFeeSchedule from "./TermsFeeSchedule.vue";
import AvidiaTermsFeeSchedule from "./AvidiaTermsFeeSchedule.vue";
import AllegacyTermsFeeSchedule from "./AllegacyTermsFeeSchedule.vue";
import * as RouteNames from "@/employee/route-names";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

// const CustodianSettingsStore = namespace("custodianSettings");
// const EnrollmentStore = namespace("enrollment");
// const UserStore = namespace("user");
// const Portal = namespace("portalCustomization");
// const FeatureFlagStore = namespace("featureFlag");

@Component({
  components: {
    Checkbox,
    Button,
    Tab,
    TabGroup,
    TermsFeeSchedule,
    AvidiaTermsFeeSchedule,
    AllegacyTermsFeeSchedule
  }
})
export default class Terms extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  enrollmentStore = useEnrollmentStore();
  portalCustomizationStore = usePortalCustomizationStore();
  featureFlagStore = useFeatureFlagStore();

  readonly bendTermsAndConditionsFile = "bend_financial_terms_of_service 20181009.pdf";

  isSubmitting = false;
  isLoaded = true;
  agreedToESignTerms = false;
  agreedToTerms = false;
  TermsTab = TermsTab;
  activeTab = TermsTab.Bank;

  mounted () {
    this.enrollmentStore.loadFeeWaiverSettings(this.userStore.partnerId);
    this.$on("tab-clicked", (event, tab) => {
      event.preventDefault();
      this.handleTabChange(tab.type);
    });
  }

  handleTabChange (tabType) {
    this.activeTab = tabType;
  }

  get termsAndConditionsHref () {
    return `/${this.bendTermsAndConditionsFile}`;
  }

  get submitDisabled () {
    return !this.agreedToESignTerms || !this.agreedToTerms;
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }

    if (!this.agreedToESignTerms && !this.agreedToTerms) {
      return;
    }

    this.isSubmitting = true;
    this.enrollmentStore.saveAgreedToTerms(this.eSignatureAgreedTo)
        .then(() => this.enrollmentStore.saveAgreedToTerms(this.custodianSettingsStore.termsUrl))
        .then(() => this.enrollmentStore.saveAgreedToTerms(this.bendTermsAndConditionsFile))
        .then(() => {
          this.enrollmentStore.saveAgreedToFeeTerms();
          return this.enrollmentStore.termsAccepted();
        })
        .then(() => this.$emit("complete"))
        .finally(() => this.isSubmitting = false);
  }

  get eSignatureAgreedTo () {
    if (this.custodianSettingsStore.displayPdfForESign) {
      return this.custodianSettingsStore.eSignPdfUrl;
    }

    return "inline-content-esign-disclosure-as-of-2021-07-13";
  }

  get bendTermsSource () {
    if (this.activeTab === TermsTab.FeeSchedule) {
      return this.$router.resolve({ name: RouteNames.FeeSchedulePrint }).href;
    }
    if (this.activeTab === TermsTab.Bank) {
      return this.custodianSettingsStore.termsUrl;
    } else {
      return this.termsAndConditionsHref;
    }
  }

  get showAllegacyDynamicFees (): boolean {
    return this.custodianSettingsStore.userCustodian === BankCustodian.Allegacy &&
        this.featureFlagStore.featureFlagsAvailable && this.featureFlagStore.flags.showDynamicAllegacyFees;
  }
}
